<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          แผนงานที่เปิดรับ
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="jam:world"
                @onChange="searchData.keyword = $event"
                @onEnter="getProjects()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>
    <pre>{{ keyword }}</pre>
    <div class="list-layout">
      <AvailablePlanItem
          v-for="(item, i) in planList"
          :key="i"
          :item="item"
      ></AvailablePlanItem>
    </div>

    <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getProjects"
    ></v-pagination>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import AvailablePlanItem from "../../components/AvailablePlanItem"
import { mapState } from "vuex"

export default {
  name: "AvailablePlan",
  components: {
    TextField,
    AvailablePlanItem
  },
  data () {
    return {
      planList: [
        // {
        //   plan_code: '#123',
        //   plan_name_th: 'แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์',
        //   plan_name_eng: 'Service Platform',
        // },
        // {
        //   plan_code: '#123',
        //   plan_name_th: 'แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์',
        //   plan_name_eng: 'Service Platform',
        // },
        // {
        //   plan_code: '#123',
        //   plan_name_th: 'แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์',
        //   plan_name_eng: 'Service Platform',
        // },
      ],
      searchData: {
        keyword: null
      },
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    }
  },
  created () {
    this.getProjects()
  },
  computed: {
    ...mapState({
      userRole: state => state.Auth.User?.user_type
    })
  },
  methods: {
    async getProjects (page) {
      let res
      let payload = {
        // status: this.searchData.status ?? this.statusMaster.join(','),
        page: page,
        keyword: this.searchData.keyword
      };

      if (this.userRole === 'USP') {
        res = await this.$apiFire('MainProject/getMainProjectsByUSP', payload)
      } else {
        res = await this.$apiFire('MainProject/getMainProjects', payload)
      }
      this.planList = res.data;
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    }
  }
}
</script>

<style scoped lang="scss">
.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>